import React from 'react';

const Blog = () => {return (
		<iframe 
			title='Napland Games Blog'
			style={{width: '100%', height: '98VH', border: 'none', marginTop:'-90px'}}
			src='https://blog.naplandgames.com'/>);
	}
export default Blog;